import translator from "@/translator";
import React from "react";
import { Avatar, Typography } from "antd";
import ProfileMenu from "./components/ProfileMenu";
import SubscriptionCard from "@/note_office/shared/SubscriptionCard";

const { Title, Text } = Typography;

const t = translator("note_office.views.profile.index_view.");

const IndexView = ({ profileData, tariffEndDate, balance }) => {
  return (
    <div className="wrapper wrapper__menu-layout overflow">
      <div className="profile__header">
        <Avatar
          size={80}
          className="profile__avatar"
          style={{ backgroundColor: profileData.color }}
        >
          {profileData.account_letter}
        </Avatar>
        <Title level={4} className="profile__name">
          {profileData.name || profileData.email}
        </Title>
      </div>

      <div className="profile__card">
        <SubscriptionCard
          sub_name={profileData.subscription.name}
          sub_paid_until={profileData.subscription.paid_until}
        />
        <p type="secondary" className="profile__balance">
          {t("sms_balance")}: {profileData.balance}
        </p>
      </div>

      <div className="profile__menu-container overflow">
        <ProfileMenu profileData={profileData} />
      </div>
    </div>
  );
};

export default IndexView;
